import React, { useEffect } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { forgotPassToken } from 'js/hooks/auth/pas';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { languageService } from 'js/services/language.service';

export const useForgotPasswordByToken = (fpActionToken: string, setFormError: React.Dispatch<React.SetStateAction<string>>) => {
    const isMounted = useIsMounted();
    const getErrorMessage = useGetErrorMessage();
    const lang = useUserSelector(prop('lang'));

    useEffect(() => {
        if (!fpActionToken) {
            return;
        }

        (async (): Promise<void> => {

            try {
                const response = await forgotPassToken({
                    fpActionToken, languageCode: languageService.convertToIMS(lang)
                });

                if (!response.data?.sessionValidationData?.SessionValidationByPasswordChangeData?.[0]) {
                    isMounted() && setFormError(getErrorMessage(response));
                }
            } catch (error) {
                isMounted() && setFormError(getErrorMessage(error));
            }
        })();
    }, [lang, isMounted, setFormError, fpActionToken, getErrorMessage]);
};
